<template>
  <div
    class="service-table"
    v-bind:class="[
      { 'is-full': isAllVisibleColumns && !shownSearchColumns },
      { 'is-enough-columns-search': hasEnoughColumnsForSearch },
    ]"
  >
    <service-table-head
      class="service-table__head"
      v-bind:columns="visibleColumns"
      v-bind:shown-search-columns="shownSearchColumns"
      v-bind:has-edit="hasEdit"
      v-bind:has-create="hasCreate"
      v-bind:has-delete="hasDelete"
    >
      <div slot="clinic_code" class="service-table__cell is-clinic-code">
        <span class="service-table__cell__help">
          Код клиники
          <help-icon v-bind:tooltip-text="clueClinicCode" />
        </span>
      </div>
      <div
        v-if='false'
        slot="dental_service_code"
        class="service-table__cell is-item-code">
        <span class="service-table__cell__help">
          Код номенклатуры
          <help-icon v-bind:tooltip-text="clueCode" />
        </span>
      </div>
      <div slot="name" class="service-table__cell is-name">Наименование</div>
      <div slot="price" class="service-table__cell is-price">Стоимость, тнг</div>
      <div slot="category" v-if="shownSearchColumns" class="service-table__cell is-category">Категория</div>
      <div slot="price_list" v-if="shownSearchColumns" class="service-table__cell is-price-name">Прайс</div>
      <div slot="show_on_price" class="service-table__cell" v-if="hasEdit" />
      <div slot="favorite" class="service-table__cell" v-if="hasEdit" />
      <div slot="edit" class="service-table__cell" v-if="hasEdit" />
      <div slot="delete" class="service-table__cell is-delete" v-if="hasDelete" />
      <template v-slot:settings>
        <popover-menu
          v-on:input="resetCountChanges"
        >
          <template v-slot:trigger="{ listenerObject }">
            <div class="service-table__cell service-table__settings is-settings">
              <button
                v-on="listenerObject"
                class="service-table__icon-settings"
                type="button"
              />
            </div>
          </template>
          <form-table-settings
            v-bind:columns="columnSettings"
            v-on:change="onChangeColumnSettings"
          />
        </popover-menu>
      </template>
    </service-table-head>
    <div class="service-table__body-mobile">
      <button
        class="service-table__body-mobile__row"
        v-bind:class="{ search: shownSearchColumns, 'no-edit': !hasEdit }"
        type="button"
        v-for="{
          id,
          code,
          name,
          price,
          categoryName,
          priceListName,
          isFavorite,
          isHidden,
          clinicCode,
        } in serviceList"
        v-bind:key="id"
        v-on:click="dispatchView(id)"
      >
        <div class="service-table__body-mobile__row__data">{{ clinicCode }}</div>
        <div v-if='false' class="service-table__body-mobile__row__data">{{ code }}</div>
        <div class="service-table__body-mobile__row__data">{{ name }}</div>
        <span v-if="shownSearchColumns">Категория</span>
        <div v-if="shownSearchColumns">{{ categoryName }}</div>
        <span v-if="shownSearchColumns">Прайс</span>
        <div v-if="shownSearchColumns">{{ priceListName }}</div>
        <span>Стоимость</span>
        <div>{{ price }} тнг</div>
        <div class="service-table__body-mobile__row__actions">
          <v-switch
            title="Выводить в прайсе"
            @click.stop="dispatchToggleHidden(id)"
            v-bind:input-value="!isHidden"
            inset
            hide-details />
          <button
            type="button"
            title="Добавить в избранное"
            class="service-table__icon-favorite"
            v-bind:class="{ favorite: isFavorite }"
            v-on:click.stop="dispatchToggleFavorite(id)"
          />
          <button
            type="button"
            title="Дублировать"
            class="service-table__icon-copy"
            v-on:click.stop="dispatchCopy(id)"
          />
        </div>
      </button>
    </div>
    <div class="service-table__body">
      <service-table-row
        v-for="service in serviceList"
        v-bind:key="service.id"
        v-bind:columns="visibleColumns"
        v-bind:row="service"
        v-bind:shown-search-columns="shownSearchColumns"
        v-bind:has-edit="hasEdit"
        v-bind:has-delete="hasDelete"
        v-bind:is-await-request="isAwaitRequest"
        v-bind:draggable="!isFocused"
        v-bind:data-service-id="service.id"
        v-on:dragenter="onDragServiceItem"
        v-on:dragend="onDropServiceItem"
        v-on:dragover="onDragover"
        v-on:dragstart="onStartDragServiceItem"
        v-on:focusin="focusedEnabled"
        v-on:focusout="focusedDisabled"
      >
        <div slot='clinic_code' class="service-table__cell service-table__cell__name is-clinic-code">
          <input-text
            title=""
            v-bind:allowed-null="true"
            v-bind:without-native-controls="true"
            v-bind:value="service.clinicCode"
            v-bind:maxlength="10"
            v-on:blur="onUpdateClinicCode(service.id, $event)"
          />
        </div>
        <div
          v-if='false'
          slot='dental_service_code'
          class="service-table__cell service-table__cell__name is-item-code"
          data-label="Код номенклатуры">
          <input-text
            title=""
            v-bind:value="service.code"
            v-on:blur="onUpdateCode(service.id, $event)"
          />
        </div>
        <div slot='name' data-label="Наименование" class="service-table__cell service-table__cell__name is-name">
          <v-textarea
            class="service-table__input"
            v-bind:value="service.name"
            v-bind:readonly="!hasEdit"
            v-on:change="onUpdateName(service.id, $event)"
            no-resize
            rows="1"
            auto-grow
            hide-details
          />
        </div>
        <div
          slot='price'
          id="price-list-button-price-edit-parent"
          data-label="Стоимость, тнг"
          class="service-table__cell is-price">
          <price-input
            class="service-table__unit"
            v-bind:value="parseFloat(service.price) * 100"
            v-on:blur="onUpdatePrice(service.id, $event)"
            v-bind:disabled="!hasEdit"
            without-kopeck
          />
        </div>
        <div slot='category' class="service-table__cell is-category" data-label="Категория">
          {{ service.categoryName }}
        </div>
        <div slot='price_list' class="service-table__cell is-price-name" data-label="Прайс">
          {{ service.priceListName }}
        </div>
        <div slot='show_on_price' class="service-table__cell is-show_on_price" data-label="Видимость">
          <v-switch
            title="Выводить в прайсе"
            @click.stop="dispatchToggleHidden(service.id)"
            v-bind:input-value="!service.isHidden"
            inset
            hide-details />
        </div>
        <div slot='favorite' class="service-table__cell is-favorite" data-label="Избранное">
          <button
            type="button"
            title="Добавить в услуги для записи"
            class="service-table__icon-favorite"
            v-bind:class="{ favorite: service.isFavorite }"
            v-on:click.stop="dispatchToggleFavorite(service.id)"
          />
        </div>
        <div slot='edit' class="service-table__cell is-edit" data-label="Редактировать">
          <button
            type="button"
            title="Редактировать"
            class="service-table__icon-edit"
            v-on:click="dispatchView(service.id)"
          />
        </div>
        <div slot='delete' class="service-table__cell is-delete" data-label="Удалить">
          <button
            type="button"
            title="Удалить"
            class="service-table__icon-delete"
            v-bind:disabled="isAwaitRequest"
            v-on:click="dispatchDelete(service.id)"
          />
        </div>
        <div slot='settings' class="service-table__cell is-settings" />
      </service-table-row>
    </div>
  </div>
</template>
<script>
import { EditServiceRequest } from '@/storage/gateways/ServiceGateway';
import PriceInput from '@/components/PriceInput.vue';
import InputText from '@/components/InputText.vue';
import HelpIcon from '@/components/HelpIcon.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import FormTableSettings from '@/components/FormTableSettings.vue';

/**
 * Меняем порядок услуг
 *
 * @type {string}
 */
const CHANGE_CATEGORY_ORDER = 'change-order-service';

/**
 * @description Максимальное количество попыток в рекурсии.
 * @type {number}
 */
const MAX_ATTEMPTS_IN_RECURSION = 10;

/**
 * @description Название события копирования услуги.
 * @type {string}
 */
const NAME_EVENT_COPY = 'copy';

/**
 * @description Название события удаления услуги.
 * @type {string}
 */
const NAME_EVENT_DELETE = 'delete';

/**
 * @description Название события редактирования услуги.
 * @type {string}
 */
const NAME_EVENT_EDIT = 'edit';

/**
 * @description Название события переключения избранного.
 * @type {string}
 */
const NAME_EVENT_TOGGLE_FAVORITE = 'toggle-favorite';

const NAME_EVENT_DELETE_SELECTED_SERVICE = 'remove-selected-service';

const NAME_EVENT_ADD_SELECTED_SERVICE = 'add-selected-service';

/**
 * @description Название события переключения видимости.
 * @type {string}
 */
const NAME_EVENT_TOGGLE_HIDDEN = 'toggle-hidden';

/**
 * @description Название события просмотра услуги.
 * @type {string}
 */
const NAME_EVENT_VIEW = 'view';

/**
 * @description Событие выбора элемента.
 * @type {string}
 */
const ON_SET_DRAGGED_ELEMENT = 'set-dragged-element';

const COLUMN_KEYS = {
  clinic_code: 'clinicCode',
  dental_service_code: 'dentalServiceCode',
  name: 'name',
  price: 'price',
};

/**
 * @description Компонент заголовка таблицы услуг.
 */
const ServiceTableHead = {
  functional: true,
  name: 'ServiceTableHead',
  props: {
    columns: { required: true, type: Array },
    shownSearchColumns: { required: true, type: Boolean },
    hasEdit: { required: true, type: Boolean },
    hasCreate: { required: true, type: Boolean },
    hasDelete: { required: true, type: Boolean },
  },
  render(createElement, { props, slots }) {
    const scopedSlots = slots();
    const makeCell = (label, key) => createElement(
      'div',
      { staticClass: `service-table__cell is-${key}`, key: `head-${key}` },
      label,
    );
    const children = [
      ...props.columns.map((column) => {
        if (scopedSlots[column.id]) {
          return scopedSlots[column.id];
        }
        return makeCell('', column.id);
      }),
      props.shownSearchColumns ? scopedSlots.category : [],
      props.shownSearchColumns ? scopedSlots.price_list : [],
      props.hasEdit ? makeCell('', 'show_on_price') : [],
      props.hasEdit ? makeCell('', 'favorite') : [],
      props.hasEdit ? makeCell('', 'edit') : [],
      props.hasDelete ? makeCell('', 'delete') : [],
      scopedSlots.settings,
    ];
    return createElement(
      'div',
      {
        staticClass: 'service-table__head',
        class: { search: props.shownSearchColumns, 'no-edit': !props.hasEdit },
      },
      children,
    );
  },
};

/**
 * @description Компонент строки таблицы услуг.
 */
const ServiceTableRow = {
  functional: true,
  name: 'ServiceTableRow',
  props: {
    columns: { required: true, type: Array },
    row: { required: true, type: Object },
    shownSearchColumns: { required: true, type: Boolean },
    hasEdit: { required: true, type: Boolean },
    hasDelete: { required: true, type: Boolean },
    isAwaitRequest: { required: true, type: Boolean },
  },
  render(createElement, {
    props,
    slots,
    data,
  }) {
    const allSlots = slots();
    const getSlot = (name) => (allSlots[name] ? allSlots[name] : []);
    const children = [
      ...props.columns.map((column) => {
        if (allSlots[column.id]) {
          return getSlot(column.id);
        }
        const rowKey = COLUMN_KEYS[column.id];
        const text = props.row[rowKey] || '';
        return createElement(
          'div',
          {
            staticClass: 'service-table__cell',
            attrs: { 'data-label': column.name },
          },
          text,
        );
      }),
      props.shownSearchColumns ? getSlot('category') : [],
      props.shownSearchColumns ? getSlot('price_list') : [],
      props.hasEdit ? getSlot('show_on_price') : [],
      props.hasEdit ? getSlot('favorite') : [],
      props.hasEdit ? getSlot('edit') : [],
      props.hasDelete ? getSlot('delete') : [],
      props.hasDelete ? getSlot('settings') : [],
    ];
    return createElement(
      'div',
      {
        ...data,
        staticClass: 'service-table__row',
        class: {
          search: props.shownSearchColumns,
          'no-edit': !props.hasEdit,
        },
      },
      children,
    );
  },
};

/**
 * @description Таблица услуг.
 * @type {any}
 */
export default {
  components: {
    FormTableSettings,
    PopoverMenu,
    HelpIcon,
    InputText,
    PriceInput,
    ServiceTableRow,
    ServiceTableHead,
  },
  computed: {
    /**
     * @description Имеет право создавать услуги.
     * @returns {boolean}
     */
    hasCreate() {
      return this.actions.includes('add');
    },
    /**
     * @description Имеет право удалять услуги.
     * @returns {boolean}
     */
    hasDelete() {
      return this.actions.includes('delete');
    },
    /**
     * @description Имеет право редактировать услуги.
     * @returns {boolean}
     */
    hasEdit() {
      return this.actions.includes('edit');
    },
    /**
     * @description Видимые столбцы.
     * @returns {any[]}
     */
    visibleColumns() {
      return this.columns.filter((candidate) => candidate.is_visible);
    },
    /**
     * @description Все ли отображены столбцы.
     * @returns {boolean}
     */
    isAllVisibleColumns() {
      return this.visibleColumns.length === this.columnSettings.length;
    },
    /**
     * @description Имеет достаточно видимых столбцов в режиме поиска.
     * @returns {boolean}
     */
    hasEnoughColumnsForSearch() {
      return this.shownSearchColumns && this.visibleColumns.length > 2;
    },
  },
  data() {
    return {
      /**
       * @description Имеется ли фокусировка
       * @type {Boolean}
       */
      isFocused: false,
      /**
       * @description Выбранный элемент методом Drag and drop.
       * @type {HTMLElement|null}
       */
      selectedElementByDrag: null,
      /**
       * @description Подсказка для колонки "код клиники".
       * @type {String}
       */
      clueClinicCode: 'Внутренний код клиники. Не обязательно к заполнению',
      /**
       * @description Подсказка для колонки "код номенклатуры".
       * @type {String}
       */
      clueCode: 'Перечень кодов и наименований медицинских услуг, утвержденный приказом Минздрава №804н',
      /**
       * @description Выбранные Id услуг.
       * @type Array<Number>
       */
      selectedService: [],
      /**
       * @description Выбраны ли все сервисы.
       * @type {Bool}
       */
      isSelectedAllService: false,
    };
  },
  methods: {
    /**
     * @description Увеличить количество изменений над настройками
     * @returns {void}
     */
    incrementCountChanges() {
      this.countSettingsChanges += 1;
    },
    /**
     * @description Сбросить счётчик изменений над настройками
     * @returns {void}
     */
    resetCountChanges() {
      this.countSettingsChanges = 0;
    },
    /**
     * @description Обработать изменение настроек.
     * @returns {void}
     */
    onChangeColumnSettings(columns) {
      this.$emit('change-column-settings', columns);
      this.incrementCountChanges();
    },
    /**
     * @description Обработать старт перетаскивания элемента.
     * @param event
     */
    onStartDragServiceItem(event) {
      this.selectedElementByDrag = this.getServiceItemRow(event.target);
      this.$emit(ON_SET_DRAGGED_ELEMENT, event.target);
    },
    /**
     * @description Обработать события начала перетаскивания элемента услуги.
     *
     * @param {event} event
     */
    onDragover(event) {
      event.preventDefault();
      if (!this.draggedElement?.classList.contains('service-table__row')) {
        /* eslint-disable-next-line no-param-reassign */
        event.dataTransfer.dropEffect = 'none';
      }
    },
    /**
     * @description Обработать события при определении нового места для выбранного категории.
     * @param {Event} event
     * @return {void}
     */
    onDropServiceItem(event) {
      const targetRow = this.defineServiceRow(event);
      if (!targetRow || !this.selectedElementByDrag) {
        return;
      }
      const selectedCategoryId = this.selectedElementByDrag.getAttribute('data-service-id');
      const enteredCategoryId = targetRow.getAttribute('data-service-id');
      if (!selectedCategoryId || !enteredCategoryId) {
        return;
      }
      this.$emit(CHANGE_CATEGORY_ORDER, {
        selectedElementId: selectedCategoryId,
        enteredElementId: enteredCategoryId,
      });
      this.$emit(ON_SET_DRAGGED_ELEMENT, null);
      targetRow.classList.remove('service-item__drag-selected-element');
    },
    /**
     * Обработать события начала перетаскивания элемента услуги.
     *
     * @param {event} event
     */
    onDragServiceItem(event) {
      this.disableDragSelectedStyle();
      this.dispatchSetDragSelectElement(event);
    },
    /**
     * @description Отключить стили для прежде наведенных элементов
     *
     * @return {void}
     */
    disableDragSelectedStyle() {
      document.querySelectorAll('.service-item__drag-selected-element')
        .forEach((el) => {
          el.classList.remove('service-item__drag-selected-element');
        });
    },
    /**
     * @description Отправить событие вставить элемент на который навились методом drag.
     * @param {event} event Элемент categoryItem.
     * @returns {void}
     */
    dispatchSetDragSelectElement(event) {
      const row = this.defineServiceRow(event);
      if (!row || !this.draggedElement?.classList.contains('service-table__row')) {
        return;
      }
      row.classList.add('service-item__drag-selected-element');
    },
    /**
     * @description Определить строку услуги.
     *
     * @param {Event} event
     *
     * @returns {HTMLElement|null}
     */
    defineServiceRow(event) {
      const { clientX, clientY } = event;
      const element = document.elementFromPoint(clientX, clientY);
      return this.getServiceItemRow(element, 0);
    },

    /**
     * @description Получить строку услуги по элементу.
     * @param {HTMLElement} element
     * @param {number} attempts
     * @returns {HTMLElement|null}
     */
    getServiceItemRow(element, attempts) {
      if (attempts >= MAX_ATTEMPTS_IN_RECURSION || !element) {
        return null;
      }
      if (!element.classList.contains('service-table__row')) {
        return this.getServiceItemRow(element.parentElement, attempts + 1);
      }
      return element;
    },
    onClickCheckbox(id) {
      const isSelected = this.selectedService[id];
      if (!isSelected) {
        this.$emit(NAME_EVENT_DELETE_SELECTED_SERVICE, id);
      } else {
        this.$emit(NAME_EVENT_ADD_SELECTED_SERVICE, id);
      }
    },
    /**
     * @description Обработать события нажатия на переключатель.
     * @returns {void}
     */
    onClickSelectedAllToggle() {
      if (this.isSelectedAllService) {
        this.selectAllServices();
      } else {
        this.clearAllServices();
      }
    },
    /**
     * @description Очистить все выбранные услуги
     * @returns {void}
     */
    clearAllServices() {
      this.changeAllSelectedServices(false);
      this.isSelectedAllService = false;
    },
    /**
     * @description Выбрать все услуги
     * @returns {void}
     */
    selectAllServices() {
      this.changeAllSelectedServices(true);
      this.isSelectedAllService = true;
    },
    /**
     * @description Изменить состояние выбора у всех услуг
     * @param isSelected
     */
    changeAllSelectedServices(isSelected) {
      const emitName = isSelected
        ? NAME_EVENT_ADD_SELECTED_SERVICE
        : NAME_EVENT_DELETE_SELECTED_SERVICE;
      this.serviceList.forEach((item) => {
        this.selectedService[item.id] = isSelected;
        this.$emit(emitName, item.id);
      });
      this.selectedService = this.selectedService.slice();
    },
    /**
     * @description Отправить событие копирования услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchCopy(id) {
      this.$emit(NAME_EVENT_COPY, id);
    },
    /**
     * @description Отправить событие удаления услугу.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchDelete(id) {
      this.$emit(NAME_EVENT_DELETE, id);
    },
    /**
     * @description Отправить событие редактирования услуги.
     * @param {Service} service Услуга.
     * @returns {void}
     */
    dispatchEdit(service) {
      const request = new EditServiceRequest(service.id, service);
      this.$emit(NAME_EVENT_EDIT, request);
    },
    /**
     * @description Отправить событие просмотра услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchToggleFavorite(id) {
      this.$emit(NAME_EVENT_TOGGLE_FAVORITE, id);
    },
    /**
     * @description Отправить событие переключения видимости услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchToggleHidden(id) {
      this.$emit(NAME_EVENT_TOGGLE_HIDDEN, id);
    },
    /**
     * @description Отправить событие просмотра услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchView(id) {
      this.$emit(NAME_EVENT_VIEW, id);
    },
    /**
     * @description Обработать обновление названия услуги.
     * @param {int}    id Идентификатор услуги
     * @param {string} newName Название услуги
     */
    onUpdateName(id, newName) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.name !== newName;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ name: newName }));
      }
    },
    /**
     * @description Обработать обновление кода клиники.
     * @param {int}    id            Идентификатор услуги.
     * @param {number} newClinicCode Код клиники.
     */
    onUpdateClinicCode(id, newClinicCode) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.clinicCode !== newClinicCode;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ clinicCode: newClinicCode }));
      }
    },
    /**
     * @description Фокусировка включена.
     * @returns {void}
     */
    focusedEnabled() {
      this.isFocused = true;
    },
    /**
     * @description Фокусировка отключена.
     * @returns {void}
     */
    focusedDisabled() {
      this.isFocused = false;
    },
    /**
     * @description Обработать обновление кода номенклатуры.
     * @param {int}    id      Идентификатор услуги.
     * @param {number} newCode Код номенклатуры.
     */
    onUpdateCode(id, newCode) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.code !== newCode;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ code: newCode }));
      }
    },
    /**
     * @description Обработать обновление цены.
     * @param {number} id       Идентификатор.
     * @param {number} newPrice Новая цена.
     * @returns {void}
     */
    onUpdatePrice(id, newPrice) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.price * 100 !== newPrice * 100;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ price: newPrice }));
      }
      this.focusedDisabled();
    },
  },
  name: 'ServiceTable',
  props: {
    /**
     * @description Допустимые действия.
     */
    actions: { required: true, type: Array },
    /**
     * @description Настройки столбцов.
     */
    columnSettings: { required: true, type: Array },
    /**
     * @description Cтолбцы.
     */
    columns: { required: true, type: Array },
    /**
     * @description Ожидает запроса.
     * @type {Boolean}
     */
    isAwaitRequest: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    /**
     * Переносимый элемент методом drag
     * @type {HTMLElement|null}
     */
    draggedElement: {
      type: HTMLElement,
      required: false,
      default: () => {},
    },
    /**
     * @description Опции кодов услуг для налоговой.
     */
    serviceTaxCodeOptions: { required: true, type: Array },
    /**
     * @description Список услуг.
     */
    serviceList: { required: true, type: Array },
    /**
     * @description Отображать столбцы при поиске.
     */
    shownSearchColumns: { default: () => false, type: Boolean },
  },
};
</script>
<style lang="scss">
.service-item {
  &__drag-selected-element{
    border-image: linear-gradient(#0489e0 0%, #ffffff 2%) 1;
    border-top: 15px;
    border-style: solid;
  }
}
.cell-checkbox {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -15px 0 0 -15px;
  display: flex;
  justify-content: center;
}
.service-table {
  counter-reset: counterServices;
  flex-basis: auto;
  width: 100%;
  overflow-x: auto;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: end;
      row-gap: 5px;
      padding: 5px;
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
      &__actions {
        grid-column: 1 / 3;
        display: flex;
        align-items: center;
        gap: 15px;
        .v-input--selection-controls__input:hover,
        .v-input--selection-controls__ripple:before {
          content: none;
        }
        .v-input--selection-controls__ripple {
          display: none;
        }
        .v-input--switch .v-input--switch__track {
          background: white !important;
          border: 1px solid #c2cfe0;
          border-radius: 15px;
          opacity: 1 !important;
        }
        .v-input--switch .v-input--switch__thumb {
          color: #90a0b7;
        }
        .v-input--selection-controls {
          margin: 0 !important;
          padding: 5px !important;
        }
      }
      &__checkbox {
        justify-self: start;
        margin: 0;
        .v-input--selection-controls__input:hover {
          content: none;
        }
        .v-input--selection-controls__ripple {
          display: none;
        }
      }
      &__data {
        grid-column: 1 / 3;
        text-align: right;
      }
      & > span {
        justify-self: start;
      }
    }
  }
  &__head,
  &__row {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &:is(.is-full) &__head,
  &:is(.is-full) &__row {
    min-width: 820px;
  }
  &:is(.is-enough-columns-search) &__head,
  &:is(.is-enough-columns-search) &__row {
    min-width: 1080px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
    padding: 5px 0;
    padding-left: 15px;
    min-height: 46px;
  }
  &__row {
    position: relative;
    border-bottom: 1px solid #eaeff3;
    padding: 12px 0;
    padding-left: 15px;
    cursor: grab;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 3px;
      display: none;
      width: 20px;
      height: 20px;
      mask-image: url("@/assets/img/drag-indicator.svg");
      mask-repeat: no-repeat;
      mask-position: center center;
      mask-size: contain;
      background-color: #90A0B7;
      transform: translateY(-50%);
    }
    &:hover {
      background: #eaeff3;
      &::before {
        display: block;
      }
    }
  }
  &__unit {
    width: 100%;
  }
  &__cell {
    padding: 0 8px;
    &__help {
      display: flex;
      >img {
        width: 20px;
      }
    }
    &--checkbox {
      padding-inline: 17px 8px;
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.number:after {
      counter-increment: counterServices;
      content: counter(counterServices);
    }
    &__color {
      width: 15px;
      height: 15px;
      border-radius: 50%;
    }
    &__name {
      color: var(--action-color);
      input, .v-input {
        font-size: 14px;
      }
    }
    &__checkbox {
      margin: 2.5px;
      width: 60px;
      height: 60px;
      position: relative;
    }
    &.is-clinic-code {
      width: 120px;
    }
    &.is-item-code {
      width: 150px;
    }
    &.is-name {
      flex: 1;
      min-width: 180px;
    }
    &.is-price {
      width: 110px;
    }
    &.is-show_on_price {
      width: 100px;
      margin-left: auto;
    }
    &.is-category {
      flex: 0.4;
      width: 180px;
    }
    &.is-price-name {
      flex: 0.3;
      width: 140px;
    }
    &:is(.is-favorite, .is-edit, .is-delete) {
      width: 43px;
    }
    &.is-settings {
      width: 34px;
    }
    .v-input--selection-controls__input:hover,
    .v-input--selection-controls__ripple:before {
      content: none;
    }
    .v-input--selection-controls__ripple {
      display: none;
    }
    .v-input--switch .v-input--switch__track {
      background: white !important;
      border: 1px solid #c2cfe0;
      border-radius: 15px;
      opacity: 1 !important;
    }
    .v-input--switch .v-input--switch__thumb {
      color: #90a0b7;
    }
    .v-input--selection-controls {
      margin: 0 !important;
      padding: 5px !important;
    }
  }
  &__input {
    width: 100%;
    border-bottom: 1px solid transparent;
    text-overflow: ellipsis;
    padding: 0 10px 0 0;
    &:focus {
      color: #212529;
      border-bottom: 1px solid #0489e0;
      outline: 0;
    }
  }
  &__settings {
    margin-left: auto;
  }
  &__icon {
    &-favorite {
      display: block;
      background-image: url("@/assets/img/star-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/star-blue.svg");
      }
      &.favorite {
        background-image: url("@/assets/img/star-blue.svg");
        &:hover {
          background-image: url("@/assets/img/star-grey.svg");
        }
      }
    }
    &-copy {
      display: block;
      background-image: url("@/assets/img/copy-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/copy-blue.svg");
      }
    }
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:not(:disabled) {
        &:hover {
          background-image: url("@/assets/img/exit-blue.svg");
        }
      }
    }
    &-settings {
      display: block;
      background-image: url("@/assets/img/settings-blue.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 18px;
      height: 18px;
      padding: 0;
      margin: 0;
      float: right;
      cursor: pointer;
    }
  }
  &__code {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--input-border-radius);
    border: 1px solid var(--border-color);
    height: 2.5rem;
    width: 100%;
  }
}
@media screen and (max-width: 1190px) {
  .service-table {
    &__head,
    &__row {
      padding: 10px 0;
    }
  }
}
@media screen and (max-width: 800px) {
  .service-table {
    &__head {
      display: none;
    }
    &__row {
      display: grid;
      grid-template-columns: 1fr !important;
      grid-gap: 10px;
      min-width: auto;
      margin: 0 0 20px 0;
      padding-left: 0;
      &::before {
        content: none
      }
    }
    &:is(.is-full) &__row,
    &:is(.is-enough-columns-search) &__row {
      min-width: auto;
    }
    & &__cell {
      display: flex;
      justify-content: space-between;
      width: auto;
      margin: 0;
      text-align: right;
      font-size: 10px;
      padding: 0;
    }
    &__unit {
      text-align: right;
      width: auto;
    }
    &__cell:before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 10px;
    }
  }
}
@media screen and (max-width: 480px) {
  .service-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}
</style>
